// src/pages/seller/Seller2Net/components/ResultsModal.js
import React from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { buildBuyerPayload } from "../../../../utils/payloadBuilder";
import { useModal } from "../../../../context/ModalContext";
import EmailModal from "../../popups/EmailModal";

export default function ResultsModal({
  step,
  setStep,
  onEditManual,
  formData,
  result,
  formatCurrency,
  cancelModal,
  handleSaveCalc,
  handleDownloadPrintPDF,
  cancelResultModal,
  resetPropNineDefaults,
  showToaster
}) {
  // const dispatch = useDispatch();
  const buyerformData = useSelector((state) => state.buyer.formData);
  const navigate = useNavigate();

  const { openModal, closeModal, closeAllModals } = useModal();

  // helper to handle closing so step resets
  const handleClose = () => {
    setStep(1); // go back to step 1 before closing
    closeModal();
    closeAllModals();
  };

  const handleExit = (e) => {
    e.preventDefault();
    closeAllModals();
    resetPropNineDefaults();
    setTimeout(() => navigate('/dashboard'), 0);
  }

  return (
    <div className="popup-data-result model-popup-style">
      {step === 1 ? (
        <>
          <div className="model-body">
            <div className="heading-gp">

              <p className="heading-b">
                {buyerformData?.main_company_name} Calculator has calculated that on a{" "}
                <b className="txtclr">
                  $ {formatCurrency(buyerformData?.salesPrice || "0.00")}
                </b>{" "}
                Sales Price and Purchase Price <br />
                <b className="txtclr">
                  $ {formatCurrency(buyerformData?.purchasePrice || "0.00")}
                </b>{" "}
                based upon the information you provided.
              </p>
            </div>

            {/* summary table */}
            <div className="tbl-top-details top-tbl-mrgn">
              <table>
                <tbody>
                  <tr>
                    <td className="txt-left heading-e txtclr">
                      <span className="clrbody">Prepared for:</span>{" "}
                      {buyerformData?.preparedFor || "New Client"},{" "}
                      {buyerformData?.addressMeta?.address || ""}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            {/* closing details */}
            <div className="tbl-type-a popup-tbl-td-width">
              <h3>Home Price & Tax Rate</h3>
              <table cellPadding="0" cellSpacing="0">
                <tbody>
                  <tr>
                    <td>Current Home - Tax Assessed Value</td>
                    <td>$ {formatCurrency(buyerformData?.loanInfoMeta?.assessedValueAmount)}</td>
                  </tr>
                  <tr>
                    <td>Current Home - Sell Price</td>
                    <td>$ {formatCurrency(buyerformData?.salesPrice || "0.00")}</td>
                  </tr>
                  <tr>
                    <td>Current Home - Purchase Price</td>
                    <td>$ {formatCurrency(buyerformData?.purchasePrice || "0.00")}</td>
                  </tr>
                  <tr>
                    <td>Property Tax Rate</td>
                    <td>{formatCurrency(buyerformData?.loanInfoMeta?.caTaxRate)} %</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="tbl-type-a popup-tbl-td-width">
              <h3>Estimated Taxes : 0-365 Days Between Sales</h3>
              <table cellPadding="0" cellSpacing="0">
                <tbody>
                  <tr>
                    <td>Current Home Adjusted Full Cash Value</td>
                    <td>$ {formatCurrency(buyerformData?.estimatedTaxes?.saleBetween365?.adjustedCash)}</td>
                  </tr>
                  <tr>
                    <td>Difference in Sale / Purchase Price</td>
                    <td>$ {formatCurrency(buyerformData?.estimatedTaxes?.saleBetween365?.diffSaleAndPurchase)}</td>
                  </tr>
                  <tr>
                    <td>Taxable Value of New Home</td>
                    <td>$ {formatCurrency(buyerformData?.estimatedTaxes?.saleBetween365?.taxableValue)}</td>
                  </tr>
                  <tr>
                    <td>Taxes with Prop 19     ($ {formatCurrency(buyerformData?.estimatedTaxes?.saleBetween365?.taxableValue)} x {formatCurrency(buyerformData?.loanInfoMeta?.caTaxRate)} %)</td>
                    <td>$ {formatCurrency(buyerformData?.estimatedTaxes?.saleBetween365?.taxWithProp19)}</td>
                  </tr>
                  <tr>
                    <td>Taxes without Prop 19     ($ {formatCurrency(buyerformData?.purchasePrice)} x {formatCurrency(buyerformData?.loanInfoMeta?.caTaxRate)} %)</td>
                    <td>$ {formatCurrency(buyerformData?.estimatedTaxes?.saleBetween365?.taxWithoutProp19)}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="tbl-type-a popup-tbl-td-width">
              <h3>Estimated Taxes : 366-730 Days Between Sales</h3>
              <table cellPadding="0" cellSpacing="0">
                <tbody>
                  <tr>
                    <td>Current Home Adjusted Full Cash Value</td>
                    <td>$ {formatCurrency(buyerformData?.estimatedTaxes?.saleBetween730?.adjustedCash)}</td>
                  </tr>
                  <tr>
                    <td>Difference in Sale / Purchase Price</td>
                    <td>$ {formatCurrency(buyerformData?.estimatedTaxes?.saleBetween730?.diffSaleAndPurchase)}</td>
                  </tr>
                  <tr>
                    <td>Taxable Value of New Home</td>
                    <td>$ {formatCurrency(buyerformData?.estimatedTaxes?.saleBetween730?.taxableValue)}</td>
                  </tr>
                  <tr>
                    <td>Taxes with Prop 19     ($ {formatCurrency(buyerformData?.estimatedTaxes?.saleBetween730?.taxableValue)} x {formatCurrency(buyerformData?.loanInfoMeta?.caTaxRate)} %)</td>
                    <td>$ {formatCurrency(buyerformData?.estimatedTaxes?.saleBetween730?.taxWithProp19)}</td>
                  </tr>
                  <tr>
                    <td>Taxes without Prop 19     ($ {formatCurrency(buyerformData?.purchasePrice)} x {formatCurrency(buyerformData?.loanInfoMeta?.caTaxRate)} %)</td>
                    <td>$ {formatCurrency(buyerformData?.estimatedTaxes?.saleBetween730?.taxWithoutProp19)}</td>
                  </tr>
                </tbody>
              </table>
            </div>


          </div>

          {/* next button */}
          <div className="model-footer">
            <div className="model-popup-button-fixed next-step-btn">
              <button
                className="submit-btn btn-bg inpt-btn"
                onClick={() => setStep(2)}
              >
                Next
              </button>
            </div>
          </div>
        </>
      ) : (
        // ✅ Step 2 — Next Actions
        <div className="model-body">
          <div className="model-popup-style">
            <div className="requiredlist-md">
              <ul>
                <li className="icon-requiredlist reqlst-edit">
                  <button
                    
                    onClick={(e) => {
                      e.preventDefault();
                      handleClose();
                      setTimeout(() => {
                        onEditManual(); // open manual edit in parent
                      }, 100); // small delay for smooth closing
                    }}
                  >
                    Open and edit the sheet manually
                  </button>

                </li>

                <li className="icon-requiredlist reqlst-download">
                  <button onClick={(e) => {
                    e.preventDefault();
                    handleDownloadPrintPDF('download', buyerformData);
                  }}>Download this sheet</button>
                </li>
                <li className="icon-requiredlist reqlst-print">
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      handleDownloadPrintPDF('print', buyerformData);
                    }}
                  >
                    Print this sheet
                  </button>
                </li>
                <li className="icon-requiredlist reqlst-email">
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      const user = JSON.parse(localStorage.getItem('user'));
                      const updated = buildBuyerPayload({
                        buyerformData, user
                      });
                      openModal({
                        title: "Email a Closing Cost Estimate",
                        size: "mediumsizewidth",
                        content: (
                          <EmailModal
                            onClose={cancelResultModal}
                            type="buyer"
                            showToaster={showToaster}
                            buyerFormData={updated}
                          />
                        )
                      });
                    }}>
                    Email this sheet
                  </button>
                </li>
                
                <li className="icon-requiredlist reqlst-cancel">
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      cancelModal()
                    }}
                  >
                    Cancel
                  </button>
                </li>
                <li className="icon-requiredlist reqlst-exit">
                  <button onClick={(e) => {
                    e.preventDefault();
                    handleExit(e);
                  }}>
                    Exit
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
